import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--background, #f5f6fa);
  direction: rtl;
  padding: 24px;
`;

const Card = styled.div<{ $variant: 'success' | 'failure' }>`
  max-width: 520px;
  width: 100%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 40px;
  text-align: center;
  border-top: 6px solid ${props => props.$variant === 'success' ? '#00ca72' : '#fb275d'};
`;

const Icon = styled.div<{ $variant: 'success' | 'failure' }>`
  font-size: 64px;
  color: ${props => props.$variant === 'success' ? '#00ca72' : '#fb275d'};
  margin-bottom: 16px;
  line-height: 1;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 12px 0;
`;

const Description = styled.p`
  font-size: 15px;
  color: #555;
  margin: 0 0 24px 0;
  line-height: 1.6;
`;

const Note = styled.div`
  font-size: 13px;
  color: #888;
  margin-top: 16px;
`;

const CardcomResult: React.FC = () => {
  const [params] = useSearchParams();
  const status = params.get('status') === 'success' ? 'success' : 'failure';

  useEffect(() => {
    // If we're inside an iframe, break out to the parent window so the user sees the full result.
    if (window.top && window.top !== window.self) {
      try {
        window.top.location.href = `/billing/cardcom-result?status=${status}`;
      } catch {
        // cross-origin - fallback: show in iframe
      }
    }
  }, [status]);

  if (status === 'success') {
    return (
      <Container>
        <Card $variant="success">
          <Icon $variant="success">✓</Icon>
          <Title>פרטי האשראי נקלטו בהצלחה</Title>
          <Description>
            כעת המערכת מסיימת את הגדרת הוראת הקבע עם Cardcom. ייפתח אישור על יצירת ההוראה תוך זמן קצר.
          </Description>
          <Note>ניתן לסגור את החלון הזה</Note>
        </Card>
      </Container>
    );
  }

  return (
    <Container>
      <Card $variant="failure">
        <Icon $variant="failure">✕</Icon>
        <Title>הסליקה נכשלה</Title>
        <Description>
          לא ניתן היה לבצע את האימות מול חברת האשראי. ניתן לחזור ולנסות שוב, או לפנות לתמיכה.
        </Description>
        <Note>ניתן לסגור את החלון הזה ולנסות מחדש</Note>
      </Card>
    </Container>
  );
};

export default CardcomResult;
